module.exports = __webpack_public_path__ + "img/scenes_15.7bccd26d.png";